import { render, staticRenderFns } from "./InstanceSearchItemSkeleton.vue?vue&type=template&id=1b1700fa&scoped=true"
import script from "./InstanceSearchItemSkeleton.vue?vue&type=script&lang=js"
export * from "./InstanceSearchItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InstanceSearchItemSkeleton.vue?vue&type=style&index=0&id=1b1700fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1700fa",
  null
  
)

export default component.exports